import React, { useContext } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import ClientContext from 'app/src/contexts/ClientContext';
import { Button } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
  EMAIL_PATTERN
} from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';

import { INVITE_USER } from './queries';

const FIELDS = {
  email: {
    rules: {
      required: true,
      pattern: { value: EMAIL_PATTERN, message: 'Enter a valid email' },
    },
  },
  name: { rules: { required: true }, },
  admin: {
    label: 'Admin User? (can manage other users access)',
    type: 'boolean',
  },
};

const NewUser = ({ setShow, refetch }) => {
  const { currentUser } = useContext(ClientContext);

  const fields = { ...FIELDS };

  const clientDefaults = {};

  const clientsCanAdmin = currentUser.clientUsers
    .filter(clientUser => clientUser.admin)
    .map(clientUser => clientUser.client);

  clientsCanAdmin.forEach(client => {
    clientDefaults[client.id] = true;

    if (clientsCanAdmin.length > 1) {
      fields[`clients.${client.id}`] = {
        label: client.name,
        type: 'boolean',
      };
    };
  });

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({
      fields,
      resource: { clients: clientDefaults }
    })
  });

  const [inviteUser] = useMutation(INVITE_USER, {
    onCompleted: () => {
      refetch();
      setShow(false);
    }
  });

  const onSubmit = ({ clients, ...input }) => {
    const preparedInput = prepareInput(input, fields);

    Object.keys(clients).forEach(id => {
      preparedInput[`clients.${id}`] = undefined
    });

    preparedInput.clientIds = clients ?
      Object.keys(clients).filter(id => clients[id]) :
      clientsCanAdmin.map(client => client.id);

    inviteUser({ variables: { input: preparedInput } });
  };

  return (
    <Modal title="Add User" setShow={setShow}>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <Text>
        If there is an account already associated with this email, the user
        will receive an email notifying them they have access to this client.
      </Text>
      <Text>
        Otherwise, the user will receive an email asking them to first set
        their password.
      </Text>


      <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
    </Modal>
  );
};

export default NewUser;
